import { fabric } from 'fabric';
import { distance, getPath } from './fabric_flowchart';
import { generateId, FABRIC_CUSTOM_OBJECT, TEXTBOX } from '../utils';
import { getIndex } from './container';

const eps = 0.5;
function distXY(A, B) {
  return Math.abs(A.x - B.x) + Math.abs(A.y - B.y);
}
function pathLength(points) {
  let sum = 0;
  for (let i = 0; i < points.length - 1; i += 1) {
    sum += distXY(points[i], points[i + 1]);
  }
  return sum;
}

function getRelativePosition(points, pageX, pageY, eps2) {
  // return x(%)
  const sum = pathLength(points);
  const p = { x: pageX, y: pageY };
  let tmp = 0;
  for (let i = 0; i < points.length - 1; i += 1) {
    if (
      Math.sqrt(distance(points[i], p)) +
        Math.sqrt(distance(p, points[i + 1])) -
        Math.sqrt(distance(points[i], points[i + 1])) <
      eps + eps2
    ) {
      // tmp += distXY(points[i], p);
      if (Math.abs(points[i].x - points[i + 1].x) <= 0.1) tmp += Math.abs(points[i].y - p.y);
      if (Math.abs(points[i].y - points[i + 1].y) <= 0.1) tmp += Math.abs(points[i].x - p.x);
      return (tmp * 100) / sum;
    }
    tmp += distXY(points[i], points[i + 1]);
  }
  return null;
}
function getAbsolutePosition(points, relativePosition) {
  // return {x:value,y:value}
  if (points.length === 2) {
    const tmpx = points[1].x - points[0].x;
    const tmpy = points[1].y - points[0].y;
    return { x: points[0].x + (tmpx * relativePosition) / 100, y: points[0].y + (tmpy * relativePosition) / 100 };
  }
  const sum = pathLength(points);
  let tmp = (relativePosition * sum) / 100;
  for (let i = 0; i < points.length - 1; i += 1) {
    if (distXY(points[i], points[i + 1]) < tmp) {
      tmp -= distXY(points[i], points[i + 1]);
    } else {
      if (Math.abs(points[i].x - points[i + 1].x) <= eps) {
        if (points[i].y < points[i + 1].y) return { x: points[i].x, y: points[i].y + tmp };
        return { x: points[i].x, y: points[i].y - tmp };
      }
      if (points[i].x < points[i + 1].x) return { x: points[i].x + tmp, y: points[i].y };
      return { x: points[i].x - tmp, y: points[i].y };
    }
  }
  console.log('getAbsolutePosition Failed');
  return null;
}
export function updateLabel(polyline) {
  const { canvas } = window;
  canvas.getObjects().forEach((e) => {
    if (e?.polylineId === polyline.id) {
      const indexLine = getIndex(polyline);
      const indexLabel = getIndex(e);
      if (indexLabel < indexLine) canvas.moveTo(e, indexLine);
      const points = getPath(polyline);
      const absolutePosition = getAbsolutePosition(points, e.relativePosition);
      e.set({
        left: absolutePosition.x - e.width / 2,
        top: absolutePosition.y - e.height / 2,
      });
      e.setCoords();
    }
  });
}
export function createLabel(polyline, pageX, pageY) {
  if (polyline.points.length === 2) return;
  const points = getPath(polyline);
  const relativePosition = getRelativePosition(points, pageX, pageY, 20);
  const absolutePosition = getAbsolutePosition(points, relativePosition);
  const label = new fabric.Textbox(FABRIC_CUSTOM_OBJECT.label, {
    name: FABRIC_CUSTOM_OBJECT.label,
    fontSize: 14,
    fontFamily: 'Helvetica',
    textAlign: 'center',
    hasControls: false,
    lockMovementX: false,
    lockMovementY: false,
    textBackgroundColor: '#fff',
    relativePosition,
    polylineId: polyline.id,
    id: generateId(),
  });
  label.set({
    left: absolutePosition.x - label.width / 2,
    top: absolutePosition.y - label.height / 2,
    centerX: absolutePosition.x,
    centerY: absolutePosition.y,
    textBackgroundColor: window.canvas.backgroundColor,
  });
  const { canvas } = window;
  canvas.add(label);
  canvas.setActiveObject(label);
  label.enterEditing();
  label.selectAll();
}

export function changeBackgroundLabel(oldColor, newColor) {
  if (!oldColor || !newColor) return;
  window.canvas.getObjects().map((e) => {
    if (e.type === TEXTBOX && e.name === FABRIC_CUSTOM_OBJECT.label && e.textBackgroundColor === oldColor) {
      e.set({ textBackgroundColor: newColor });
    }
    return e;
  });
}

export function connectLine(label) {
  label.setCoords();
  label.set({ polylineId: null });
  const position = { x: label.left + label.width / 2, y: label.top + label.height / 2 };
  const { canvas } = window;
  canvas.getObjects().map((e) => {
    if (
      e.type === FABRIC_CUSTOM_OBJECT.polyline &&
      e.name === FABRIC_CUSTOM_OBJECT.pathArrow &&
      e.left <= position.x &&
      e.top <= position.y &&
      e.left + e.width >= position.x &&
      e.top + e.height >= position.y
    ) {
      const points = getPath(e);
      const relativePosition = getRelativePosition(points, position.x, position.y, 0);
      if (relativePosition != null) {
        label.set({
          polylineId: e.id,
          relativePosition,
        });
        updateLabel(e);
      }
    }
    return e;
  });
}
